module.exports = __webpack_public_path__ + "media/images/www/guide/save_icon-b3eae86d57cc81ab6892992c7156ea48.svg";